import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import 'keen-slider/keen-slider.min.css';
import { observer } from 'mobx-react';
import queryString from 'query-string';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainBannerSlide from '@organisms/main/MainBannerSlide';
import SectionTopContents from '@organisms/main/section/TopSections';
import SectionWithBTS from '@organisms/main/section/WithBTS';
import SectionCoupon from '@organisms/main/section/Coupon';
import SectionIntroduce from '@organisms/main/partial/Introduce';
import SectionMedia from '@organisms/main/section/Media';
import { useMobxStores } from '@stores/store';
import useShrink from '@hook/useShrink';

const Main = () => {
  const { i18n } = useTranslation();
  const introRef = useRef();
  const mediaRef = useRef();
  const location = useLocation();

  const { mainStore } = useMobxStores();
  const Shrink = useShrink(introRef.current?.getBoundingClientRect().top);
  let query = queryString.parse(location.search);
  useEffect(() => {
    const handleScroll = () => {
      if (introRef.current) {
        const top = introRef.current?.getBoundingClientRect().top;
        const bottom = mediaRef.current?.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        const isElementVisible = top + 100 <= windowHeight && bottom > 0;
        mainStore.setIsActive(isElementVisible);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [query]);

  useLayoutEffect(() => {
    const position = window.scrollY || window.pageYOffSet || 0;

    if (query.menu === 'introduce' && (position > 1000 || position === 0)) {
      introRef.current?.scrollIntoView({
        block: 'start',
      });
    }
  }, [query]);

  return (
    <div className="font-nuniSans w-full h-full">
      <div className="z-50 relative">
        <MainBannerSlide />
      </div>
      <div>
        <SectionTopContents />
        <SectionIntroduce introRef={introRef} />
        <SectionMedia mediaRef={mediaRef} />
        <SectionWithBTS />

        <SectionCoupon />
      </div>
    </div>
  );
};

export default observer(Main);
